:host {
    display: inline-block;
}

.button-element span {
    top: -1px;
    display: block;
    position: relative;
    line-height: 1;
    font-size: 16px;
    font-family: soleil, sans-serif;
    font-style: normal;
    font-weight: 600;

    /* noinspection CssNonIntegerLengthInPixels */
    letter-spacing: 0.2px;
    text-decoration: none;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}

a.button-element span {
    top: initial;
}

.button-element {
    text-decoration: none;
    padding: 12px 25px;
    min-width: 90px;
    height: 42px;
    cursor: pointer;
    user-select: none;
    border: 0;
    border-radius: 4px;
    outline: none;
    display: inline-flex;
    box-sizing: border-box;
    background-size: cover;
    transition: background 0.25s ease-out, box-shadow 0.25s ease-out;
    color: var(--rs-color-white);
    width: 100%;
    white-space: nowrap;
    justify-content: center;
    align-items: center;
    gap: 8px;
}

.button-element.small {
    padding-top: 10px;
    padding-bottom: 10px;
    height: 36px;
}

.button-element.small span {
    font-size: 14px;
}

.button-element:active {
    transition-delay: 200ms;
}

:host(.expand-block),
:host(.expand-full) {
    display: block;
}

.button-element--collapse {
    min-width: auto;
    padding: 0;
    aspect-ratio: 1;
    height: auto;
}

:host(.expand-block) .button-element {
    display: block;
    width: 100%;
}

:host(.expand-full) .button-element {
    display: block;
    width: 100%;
    border-radius: 0;
}

/*
Primary Button
 */
.button-element.color--primary {
    background: var(--rs-color-primary-700);
}

.button-element.color--primary:hover {
    background: var(--rs-color-primary);
}

.button-element.color--primary:active {
    background: var(--rs-color-primary-300);
}

/*
Negative Button
 */
.button-element.color--negative {
    background: var(--rs-color-negative);
}

/*
Secondary Button
 */
.button-element.color--secondary {
    background: var(--rs-color-secondary);
}

.button-element.color--secondary:hover {
    background: var(--rs-color-secondary-700);
}

.button-element.color--secondary:active {
    background: var(--rs-color-secondary-300);
}

/*
Grey Outline Button
 */
.button-element.disabled span {
    color: var(--rs-color-white);
    pointer-events: none;
}

.button-element.color--grey-light {
    color: var(--rs-color-secondary);
    background: transparent;
    box-shadow: inset 0 0 0 1px var(--rs-color-select-border);
}

:host(.expand-block) .button-element.color--grey-light span,
:host(.expand-full) .button-element.color--grey-light span {
    font-weight: normal;
    color: var(--rs-color-secondary);
}

.button-element:not(.disabled).color--grey-light:hover {
    box-shadow: inset 0 0 0 1px var(--rs-color-grey);
}

/*
Positive Button
 */
.button-element.color--positive {
    background: var(--rs-color-positive);
}

.button-element.color--positive:hover {
    background: var(--rs-color-positive-700);
}

.button-element.color--positive:active {
    background: var(--rs-color-positive-300);
}

/*
Positive Button
 */
.button-element.color--text {
    color: var(--rs-color-grey);
    background: transparent;
}

.button-element.color--text:hover {
    background: var(--rs-color-light);
}

.button-element.color--text:active {
    background: var(--rs-color-grey-light);
}

/*
Disabled
 */
.button-element.disabled {
    box-shadow: none;
    background: var(--rs-color-grey-light);
    cursor: not-allowed;
}

.button-element.disabled:hover {
    background: var(--rs-color-grey-light);
}
